<div class="success-container" *ngIf="paymentDetails && !loading">
    <div class="success-icon"></div>
    <h2>Payment Successful!</h2>
    
    <!-- Stripe Payment Details -->
    <div *ngIf="paymentDetails.paymentType === 'stripe'">
      <p *ngIf="paymentDetails.email"><strong>Email:</strong> {{ paymentDetails.email }}</p>
      <p><strong>Amount Paid:</strong> {{ paymentDetails.amount | currency:'INR' }}</p>
      <p *ngIf="paymentDetails.paymentId"><strong>Transaction ID:</strong> {{ paymentDetails.paymentId }}</p>
    </div>

    <!-- Razorpay Payment Details -->
    <div *ngIf="paymentDetails.paymentType === 'razorpay'">
      <p *ngIf="paymentDetails.email"><strong>Email:</strong> {{ paymentDetails.email }}</p>
      <p><strong>Amount Paid:</strong> {{ paymentDetails.amount | currency:'INR' }}</p>
      <p *ngIf="paymentDetails.paymentId"><strong>Payment ID:</strong> {{ paymentDetails.paymentId }}</p>
      <p *ngIf="paymentDetails.duration"><strong>Duration:</strong> {{ paymentDetails.duration }} month(s)</p>
      <p *ngIf="paymentDetails.membershipEndDate">
        <strong>Membership Valid Until:</strong> {{ paymentDetails.membershipEndDate | date:'mediumDate' }}
      </p>
      <p *ngIf="paymentDetails.metadata?.payment_verified_at">
        <strong>Payment Verified:</strong> {{ paymentDetails.metadata.payment_verified_at | date:'medium' }}
      </p>
    </div>

    <p>Thank you for your purchase 🎉</p>
    <div class="items-center justify-center flex">
        <app-primary-button routerLink="/home/dashboard">
          <div class="gap-2 flex items-center">
            <img src="../../assets/image/Shape.png" alt="" class="h-4" />
            Let's Begin
          </div>
        </app-primary-button>
      </div>
     
</div>

<div class="success-container" *ngIf="loading">
    <div class="success-icon">⏳</div>
    <h2>Validating payment details...</h2>
    <p>Please wait while we verify your payment.</p>
</div>

<div class="success-container" *ngIf="!paymentDetails && !loading">
    <div class="success-icon">⚠️</div>
    <h2>Payment validation failed</h2>
    <p>Unable to retrieve payment details. Please contact support if you have been charged.</p>
</div>